import { createAction } from '@reduxjs/toolkit';

import { User } from '@/types/user';

export const signOut = createAction('auth/sign-out');

export const setLoggedInUser = createAction<User | undefined>(
  'auth/set-logged-in-user',
);

export const notifyUserChanged = createAction<
  { resetInit?: boolean } | undefined
>('auth/notify-user-change');
export const notifyUserChangedSolved = createAction(
  'auth/notify-user-change-solved',
);

export const requestSignOut = createAction('auth/request-sign-out');
export const cancelSignOut = createAction('auth/cancel-sign-out');

export const disableRefreshUser = createAction('auth/disable-refresh-user');
export const enableRefreshUser = createAction('auth/enable-refresh-user');
